import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Trash2 } from "lucide-react";

const pretty = (c) => (c || "").replace(/_/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());

export const allocationError = (rows) => {
  if (!rows.length) return "";
  if (rows.some((r) => !r.category)) return "Choose a service for each allocation row";
  if (new Set(rows.map((r) => r.category)).size !== rows.length) return "Each service can appear only once";
  if (rows.some((r) => !(Number(r.pct) > 0 && Number(r.pct) <= 100))) return "Each percentage must be between 0 and 100";
  const sum = rows.reduce((s, r) => s + Number(r.pct || 0), 0);
  return Math.abs(sum - 100) > 0.001 ? `Percentages total ${Math.round(sum * 100) / 100}% — they must total exactly 100%` : "";
};

export function SalaryAllocationEditor({ rows, onChange, categories }) {
  const upd = (i, k, val) => onChange(rows.map((r, idx) => (idx === i ? { ...r, [k]: val } : r)));
  const add = () => onChange(rows.length ? [...rows, { category: "", pct: "" }] : [{ category: "", pct: 100 }]);
  const err = allocationError(rows);
  return (
    <div data-testid="staff-allocation-editor">
      <div className="flex items-center justify-between">
        <Label className="text-xs">Salary allocation by service</Label>
        <button type="button" onClick={add} className="text-xs font-semibold text-slate-900 hover:underline" data-testid="staff-alloc-add">+ Add service</button>
      </div>
      {!rows.length && <p className="mt-1 text-xs text-amber-700" data-testid="staff-alloc-missing">No allocation — this salary is shown as unallocated in Service Profitability.</p>}
      <div className="mt-1 space-y-1.5">
        {rows.map((r, i) => (
          <div key={i} className="grid grid-cols-[1fr_80px_24px] items-center gap-1.5" data-testid={`staff-alloc-row-${i}`}>
            <select value={r.category} onChange={(e) => upd(i, "category", e.target.value)} className="h-9 rounded-md border border-slate-200 bg-white px-2 text-sm" data-testid={`staff-alloc-cat-${i}`}>
              <option value="">Select service</option>
              {categories.map((c) => <option key={c} value={c}>{pretty(c)}</option>)}
            </select>
            <Input type="number" value={r.pct} onChange={(e) => upd(i, "pct", e.target.value)} className="h-9" placeholder="%" data-testid={`staff-alloc-pct-${i}`} />
            <button type="button" onClick={() => onChange(rows.filter((_, idx) => idx !== i))} className="text-rose-600" data-testid={`staff-alloc-del-${i}`}><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
      {err && <p className="mt-1 text-xs text-rose-600" data-testid="staff-alloc-error">{err}</p>}
    </div>
  );
}
